import {
  cacheExchange,
  CacheExchangeOpts,
  offlineExchange,
} from "@urql/exchange-graphcache";
import { makeDefaultStorage } from "@urql/exchange-graphcache/default-storage";

import schema from "./introspection.json";

const idbName = "layer-graphcache-v1";

// jsdom doesn't provide indexedDB
const storage = import.meta.env.VITEST
  ? null
  : makeDefaultStorage({
      idbName,
      maxAge: 1,
    });

// in case of emergency, uncomment this line: explicitly disable offline cache
localStorage.setItem("experiments-offline-cache", "false");

export const createCacheExchange = (
  options: Pick<
    CacheExchangeOpts,
    "keys" | "resolvers" | "updates" | "optimistic"
  >,
) => {
  // TODO: @tuizi, after some time we can remove the `if` and simply return the offlineExchange
  if (
    // enable by default (undefined) and not explicitly disabled (false)
    localStorage.getItem("experiments-offline-cache") !== "false" &&
    storage
  ) {
    return offlineExchange({
      schema,
      storage,
      ...options,
    });
  }

  return cacheExchange({
    schema,
    ...options,
  });
};

export const clearCache = () => {
  storage?.clear();

  // delete the indexedDB database
  if (typeof indexedDB !== "undefined") {
    indexedDB.deleteDatabase(idbName);
  }
};
